var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungePet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2479 -575) translate(2479 575)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBCE63",
    fillRule: "nonzero",
    d: "M24 5c1.105 0 2 .895 2 2v6H10V7c0-1.105.895-2 2-2h12zm-1 3H13v2h10V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB619",
    d: "M8.528 10h18.944c.902 0 1.693.604 1.93 1.474l2.439 8.942c.104.38.092.784-.032 1.158l-2.353 7.058C29.184 29.45 28.419 30 27.558 30H8.442c-.861 0-1.626-.55-1.898-1.368l-2.353-7.058c-.124-.374-.136-.777-.032-1.158l2.44-8.942C6.834 10.604 7.625 10 8.527 10z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    x: 3,
    y: 18,
    fill: "#E69306",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M11.823 12.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v3c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-3c0-.069.028-.132.073-.177zM17.823 12.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v3c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-3c0-.069.028-.132.073-.177zM23.823 12.823c.246-.073.309-.045.354 0 .045.045.073.108.073.177h0v3c0 .069-.028.132-.073.177-.045.045-.108.073-.177.073-.069 0-.132-.028-.177-.073-.045-.045-.073-.108-.073-.177h0v-3c0-.069.028-.132.073-.177z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungePet);
export default __webpack_public_path__ + "static/media/lounge-pet.efb9e892.svg";
export { ForwardRef as ReactComponent };